// Characters Windows and macOS refuse in a filename.
const FORBIDDEN_FILENAME_CHARS = /[\\/:*?"<>|]/g;
// The name has no extension, so a dot ("vs. Gent") would read as one and stop
// the browser adding .pdf/.zip. A dot between digits ("12.05.2026") becomes a dash.
const DOT_BETWEEN_DIGITS = /(\d)\.(?=\d)/g;
const DOTS = /\./g;
// Chrome saves a name with no letter or digit (e.g. "---") as "download.pdf".
const HAS_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

/**
 * Names a fan's ticket download after the experience (or event), so files from
 * different experiences don't all land as "Seats (1)", "Seats (2)"... Falls
 * back to the generic label when there is no usable name.
 */
export const getTicketsFileName = (
  name: string | null | undefined,
  fallback: string
): string => {
  const fileName = name
    ?.replace(FORBIDDEN_FILENAME_CHARS, '-')
    .replace(DOT_BETWEEN_DIGITS, '$1-')
    .replace(DOTS, '')
    .replace(/\s+/g, ' ')
    .trim();

  return fileName && HAS_LETTER_OR_DIGIT.test(fileName) ? fileName : fallback;
};
